import "../Styles/Component/ServiceCard.css"
import {FaShippingFast} from "react-icons/fa"
import {MdCall} from "react-icons/md"
import {MdAttachMoney} from "react-icons/md"
import {BsBriefcaseFill} from "react-icons/bs"

const ServiceCard = () => {

    return<>
        <div className="serviceCardWrapper">
            <div className="serviceCard">
                <FaShippingFast/>
                <p>FREE SHIPPING ON ORDER OVER $99</p>
            </div>
            <div className="serviceCard">
                <MdCall/>
                <p>HAVE QUESTIONS? +2340000000000</p>
            </div>
            <div className="serviceCard">
                <MdAttachMoney/>
                <p>100% MONEY BACK GUARANTEE</p>
            </div>
            <div className="serviceCard">
                <BsBriefcaseFill/>
                <p>30 DAYS RETURN SERVICE</p>
            </div>
        </div>

    </>

}

export default ServiceCard;